import { Text, Button, Center, Flex,Select } from "@mantine/core";
import { modals } from "@mantine/modals";

import { useNavigate } from "react-router-dom";

import SRD_Form from "components/Form";
import { useState, useEffect } from "react";
import { useRecoilState } from "recoil";
import { userState } from "pages/Login/atom/userState";
import { getPathname } from "utils/getPathname";
import {
  deleteManualInfo,
  getManual,
  updateManualInfo,
} from "../apis/adminManualApis";

function ManualEditForm() {
  const [user, setUser] = useRecoilState(userState);
  const level = Number(user?.fn_level);
  const adminLevel = [0].includes(level);
  const groupId = user.fn_group_id;
 // const [selectedUsedScope, setSelectedUsedScope] = useState();

  const pk_no = getPathname();
  const navigate = useNavigate();

  const [defaultValues, setDefaultValues] = useState();

  useEffect(() => {
    getManual(pk_no).then((res) => {
      let used_scope = "1";
      if (res.menu !== "M"){
        used_scope = "2";
      }
      res["used_scope"] = used_scope;
      setDefaultValues(res);
    });
  }, [pk_no]);

  const usedScopeOptions = [
    { value: "1", label: "전체" },
    { value: "2", label: "그룹 내부" },
  ];

  const SelectUsedScope = (props) => {
    const { field, name, defaultValue } = props;
  //  setSelectedUsedScope(field.value);
    return (
      <Select
        label={name}
        data={usedScopeOptions}
        value={field.value}
   //     defaultValue={defaultValue}
        {...field}
      />
    );
  };

  const fields = [
    {
      key: "title",
      name: "이름",
      type: "text",
    },
 /* 
    {
      key: "file",
      name: "파일",
      type: "file",
    },
*/
    {
      key: "used_scope",
      name: "공개 범위",
      type: "etc",
      component: SelectUsedScope,
 //     defaultValue: selectedUsedScope,
    },
  ];

  const onSubmit = (e) => {
    modals.openConfirmModal({
      title: "수정",
      children: <Center>수정 하시겠습니까?</Center>,
   //   centered: true,
      zIndex: 2000,
      labels: { confirm: "수정", cancel: "취소" },
      onConfirm: () => {
        let grpId = defaultValues?.reg_user_group;
        updateManualInfo(e,grpId);
        navigate("/admin/manual");
      },
    });
  };

  const onDelete = (e) => {
    modals.openConfirmModal({
      title: "삭제",
   //   centered: true,
      zIndex: 2000,
      children: (
        <Center>
          <Text>정말 삭제하시겠습니까? (삭제 후 복구불가)</Text>
        </Center>
      ),
      labels: { confirm: "삭제", cancel: "취소" },
      confirmProps: { color: "red" },
      onConfirm: () => {
        deleteManualInfo(pk_no);
        navigate("/admin/manual");
      },
    });
  };

  const SubmitButton = () => {
    return (
      <Center style={{ marginTop: "1rem" }}>
        <Flex
          style={{
            width: "100%",
            justifyContent: "space-between",
            gap: "10px",
          }}
        >
          <Button color="red" onClick={() => onDelete()}
                  disabled={!adminLevel && (user?.user_id !== defaultValues?.reg_user)}
          >
            삭제
          </Button>
          <Button type="submit"
                  disabled={ !adminLevel && (user?.user_id !== defaultValues?.reg_user)}
          >
            수정
          </Button>
        </Flex>
      </Center>
    );
  };

  return (
    <SRD_Form
      fields={fields}
      onSubmit={onSubmit}
      submitButton={<SubmitButton />}
      defaultValues={defaultValues}
    />
  );
}

export default ManualEditForm;
